import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
var DEFAIULT_NO_GROUP_KEY = 'no-group';
export var useList = function useList(params) {
  var getGroupKey = params.getGroupKey,
    getItemGroupKey = params.getItemGroupKey,
    _params$items = params.items,
    items = _params$items === void 0 ? [] : _params$items,
    groups = params.groups;
  var listItems = useMemo(function () {
    if (!(groups !== null && groups !== void 0 && groups.length)) {
      return items.map(function (item) {
        return {
          type: 'item',
          element: item
        };
      });
    }
    var map = {};
    items.forEach(function (item) {
      var groupKey = getItemGroupKey(item);
      var key = typeof groupKey === 'undefined' ? DEFAIULT_NO_GROUP_KEY : groupKey;
      if (!map[key]) {
        map[key] = [];
      }
      map[key].push({
        element: item,
        type: 'item'
      });
    });
    var array = [];
    groups.forEach(function (group) {
      var key = getGroupKey(group);
      if (map[key]) {
        array.push.apply(array, [{
          type: 'group',
          element: group
        }].concat(_toConsumableArray(map[key])));
      }
      delete map[key];
    });
    array.unshift.apply(array, _toConsumableArray(Object.keys(map).reduce(function (acc, key) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(map[key]));
    }, [])));
    return array;
  }, [items, groups]);
  return {
    listItems: listItems
  };
};